import { render, staticRenderFns } from "./header.vue?vue&type=template&id=61c40acc&scoped=true&"
import script from "./header.vue?vue&type=script&setup=true&lang=js&"
export * from "./header.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=61c40acc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c40acc",
  null
  
)

export default component.exports